import Menu from '@/data/menu';

export default {
  tabs: Menu.tabs,
}
